import { styled } from "styled-components";
import { Survey } from "survey-react-ui";

const SurveyStyle = styled(Survey)`
  background-color: transparent;

  #sp_100 {
    padding: 0px 8px !important;
    margin: 0 !important;
  }

  .sd-item__control-label {
    color: ${({ theme }) => theme?.colors?.text?.paragraphs} !important;
  }

  .sv-svg-icon {
    stroke: ${({ theme }) => theme?.colors?.theme?.brandColor3} !important;
    stroke-width: 1px !important;
  }
  
  #sv-nav-complete {
    flex-grow: 0 !important;

    input {
      filter: ${({ $isDisabled }) => $isDisabled ? 'grayscale(100%)' : 'none'} !important;
      cursor: ${({ $isDisabled }) => $isDisabled ? 'not-allowed' : 'pointer'} !important;
    }
  }



`;

export default SurveyStyle;
